import { useState, useEffect } from 'react';
import { fetchBusinessHours } from '../services/hoursService';

/**
 * Custom hook to manage business hours
 * @returns {Object} Hours state and utility functions
 */
const useBusinessHours = () => {
  const [hoursData, setHoursData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadHours = async () => {
      try {
        setLoading(true);
        const data = await fetchBusinessHours();
        setHoursData(data);
        setError(null);
      } catch (err) {
        // No fallback schedule: if the API is unavailable we keep hoursData null
        console.error('Error loading hours:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    loadHours();
  }, []);

  return {
    hoursData,
    loading,
    error,
    schedule: hoursData && Array.isArray(hoursData.schedule) ? hoursData.schedule : [],
    summary: hoursData && typeof hoursData.summary === 'string' ? hoursData.summary : '',
    statusMessage: hoursData && typeof hoursData?.status?.message === 'string' ? hoursData.status.message : '',
    isOpen: hoursData && typeof hoursData?.status?.isOpen === 'boolean' ? hoursData.status.isOpen : false,
    nextChange: hoursData && hoursData?.status?.nextChange ? hoursData.status.nextChange : null,
    timezone: hoursData && typeof hoursData.timezone === 'string' ? hoursData.timezone : ''
  };
};

export default useBusinessHours;
